import { getDocsUrl } from "utils/getDocsUrl";

export const DASHBOARD_WIDGETS_STACKS_REQUIRING_ATTENTION_MIGRATION_GUIDE_URL = getDocsUrl(
  "/vendors/terraform/terragrunt#migrating-to-native-terragrunt-platform"
);
